const offersCategory = (name, depth) =>
  depth === 1 &&
  name &&
  (name.includes('Offers') || name.includes('Black Friday'));

export default offersCategory;
